module.exports = __webpack_public_path__ + "static/img/14000107.681d8bbd.png";